import React from 'react'
import PropTypes from 'prop-types'

function CalendarLayout ({ children }) {
  const classNames = [
    'calendar-layout',
    'flex',
    'flex-wrap'
  ]

  return (
    <div className='overflow-x-auto'>
      <div className={classNames.join(' ')}>
        {children}
      </div>
    </div>
  )
}

CalendarLayout.propTypes = {
}

export default CalendarLayout
